module.exports = __webpack_public_path__ + "static/media/masthead-busselton-dunsborough-times.eebb2979.svg";